module.exports = __webpack_public_path__ + "static/media/aboutBanner.43f24320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutBanner.jpg
// module id = 140
// module chunks = 0